import { Color, Radius, Spacing } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useNumberParams } from 'zens-router'
import {
  ProductInfo,
  ProductHeader,
  LayoutHeader,
  ProductFeedback,
  ProductUninstallConfirm,
  ActivityTimeline,
} from '@dms/component'
import {
  Draft,
  ProductData,
  useProduct,
  useProductMutation,
  useStore,
  useWorkspace,
  useFloor,
  useBuilding,
} from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
  },
  activities: {
    marginTop: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    paddingVertical: Spacing.M,
    paddingHorizontal: Spacing.M + Spacing.S,
  },
})

const ProductDetail = () => {
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [{ companyId, productId }] = useNumberParams()
  // const [pagination, setPagination] = usePaginationParam()
  // const [sort, setSort] = useSortParam()
  const { message } = useStore()
  const { t } = useTranslation()

  // FIXME This should be a single query, API needs to be updated
  const product = useProduct({ companyId, productId })
  const workspaceId = product.data?.workspaceId || 0
  const workspace = useWorkspace({ companyId, workspaceId })
  const floorId = workspace.data?.floorId || 0
  const floor = useFloor({ companyId, floorId })
  const buildingId = floor.data?.buildingId || 0
  const building = useBuilding({ companyId, buildingId })
  const locationId = building.data?.locationId

  const mutation = useProductMutation({ companyId })

  async function uninstall() {
    try {
      const draft = new Draft<ProductData>(product.data!.data)
      draft.data.workspace_id = undefined
      await mutation.update(draft)
      message.add({
        message: t('Device was uninstalled successfully'),
        status: 'success',
      })
      draft.settle()
      setConfirmDelete(false)
    } catch (error) {
      const { message: errorMessage } = error as Error
      console.debug(`PRODUCT: Device uninstalled failed: ${errorMessage}`)
      message.add({
        message: `${t('Device could not be uninstalled')}. ${errorMessage}`,
        status: 'error',
      })
    }
  }
  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <ProductHeader companyId={companyId} productId={productId} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<ProductInfo.Skeleton />}>
          <ProductInfo companyId={companyId} productId={productId} onUninstall={() => setConfirmDelete(true)} />
        </Suspense>
        <Suspense fallback={<ProductFeedback.Skeleton />}>
          <ProductFeedback companyId={companyId} locationId={locationId} productId={productId} />
        </Suspense>
        <Suspense fallback={<ActivityTimeline.Skeleton style={styles.activities} />}>
          <ActivityTimeline
            companyId={companyId}
            buildingId={buildingId}
            productId={productId}
            style={styles.activities}
          />
        </Suspense>
      </View>
      <ProductUninstallConfirm
        visible={!!confirmDelete}
        onClose={() => setConfirmDelete(false)}
        onUninstall={() => uninstall()}
      />
    </View>
  )
}

export default ProductDetail
